import Geocode from 'react-geocode';

import general from './general';

Geocode.setApiKey(general.MAPS_API_KEY);
Geocode.setRegion('mx');
Geocode.setLocationType('ROOFTOP');

export default Geocode;